import React from 'react';
import axios from 'axios';
import Quiz from "./Quiz";
import url from 'url';
import { config } from '../../constants/Constants';
import Loader from "./loader";
import SprachtestPostMsg from "./SprachtestPostMsg";


class Test extends React.Component{

    constructor(){
        super();
        this.state = {
            testData: [],
            loadingState: true,
            paramData:[],
            paramFrame:[]

        }
    }

    componentDidMount() {
        this.getTestData();
    }

    _shuffle(option){
        for(var j, x, i = option.length; i; j = Math.floor(Math.random() * i), x = option[--i], option[i] = option[j], option[j] = x);
        return option;
    }

    getTestData () {
        let homeurl = config.url.API_URL;
        let jsonUrl,test,paramids="",urlpath,paramFrame="";

        if(process.env.NODE_ENV === "development"){
            //urlpath = "https://sprachtest.local.de/einstufungstest-englisch?pid=57&gid=79&auth_id=1";
            urlpath = "https://sprachtest.local.de/einstufungstest-englisch?version=spiframe&footer=no&brand=zeit";
            urlpath = "https://sprachtest.local.de/einstufungstest-deutsch";
        }else{
            urlpath = window.location.href;
        }
      /*  console.log(urlpath)*/

        let urlstr = url.parse(urlpath);
        if(urlstr.path && urlstr.pathname){
            if(urlstr.path === urlstr.pathname){
                test = urlstr.path.split('-')[1];
                if(test=='business'){
                    test = test+'-'+urlstr.path.split('-')[2];
                }
            }else{
                test = urlstr.pathname.split('-')[1];
                if(test=='business'){
                    test = test+'-'+urlstr.path.split('-')[2].split('?')[0];
                }
                let location = new URL(urlpath);

                if(location.searchParams.get("pid")){
                    paramids = {
                        'pid':location.searchParams.get("pid")? location.searchParams.get("pid") :null,
                        'gid':location.searchParams.get("gid")? location.searchParams.get("gid") : null,
                        'authid':location.searchParams.get("auth_id")? location.searchParams.get("auth_id") : null,
                    }
                }else{
                    paramids = '';
                }
                /*console.log(location)
                console.log(location.searchParams.get("footer"))*/
               this.setState({paramData:paramids});
                if(location.searchParams.get("version")) {
                    paramFrame = {
                        'version': location.searchParams.get("version") ? location.searchParams.get("version") : null,
                        'footer': location.searchParams.get("footer") ? location.searchParams.get("footer") : null,
                        'brand': location.searchParams.get("brand") ? location.searchParams.get("brand") : null,
                    }
                }else{
                    paramFrame='';
                }
               /* console.log(paramFrame);*/
               /* setTimeout(()=> {*/
                    this.setState({paramFrame:paramFrame});
              /*  },200);*/


            }
        }

        /*console.log(process.env.NODE_ENV)*/
        if(process.env.NODE_ENV === "development"){
            jsonUrl = homeurl+test+'-test';
        }else{
            jsonUrl = homeurl+test+'-test';
        }
       axios
           .get(
               jsonUrl
           )
           .then(data => {

               let jsonResult = data.data;
               /*console.log(data.data)*/
               data.data.map((obj,index)=>{
                   if(obj['field_multiple_choice_ques'] =="1") {

                       let optArr = [];
                       optArr.push([1,obj['field_answers'][0],obj['field_answers'][1]])
                       optArr.push([2,obj['field_answers'][2],obj['field_answers'][3]])
                       optArr.push([3,obj['field_answers'][4],obj['field_answers'][5]])

                       obj['field_answers'] = [obj['field_answers'],this._shuffle(optArr)];


                   }else if(obj['field_gap_question'] == "1"){

                       obj['field_answers'] = obj['field_answers'];
                   }
                   else{
                       let optArr = [];
                       let optAddArr = [];
                       obj['field_answers'].map((answer, i) => {
                           let opt = [i + 1, answer];
                           optArr.push(opt)
                       })
                       obj['field_answers'] = this._shuffle(optArr);
                       if (obj['field_additional_answers'] != "") {
                           obj['field_additional_answers'].map((addAnswer, j) => {
                               let optAdd = [j + 1, addAnswer];
                               optAddArr.push(optAdd)
                           })
                           obj['field_additional_answers'] = this._shuffle(optAddArr);
                       }
                   }
               })
               /*console.log(data.data)*/
                this.setState({testData: data.data, loadingState: false});
            })
           .catch(err => {
           console.log('Error happened during fetching!', err);
           });
        //console.log(this.state.testData);
    }
    render(){
       /* console.log('hi test')*/

     /*   console.log(this.state.testData)*/
       /* console.log(this.state.paramFrame)*/
        return(

            this.state.loadingState?
                <Loader/>:
                <div>
                   {/* <SprachtestPostMsg/>*/}
                <Quiz
                    data={this.state.testData}
                    paramData={this.state.paramData}
                    paramFrame={this.state.paramFrame}/>
                </div>
        );




    }
}

/*const styles = StyleSheet.create({
    loader:{
        /!*background: url("../images/loader.gif")*!/
        width:20,
        height:20,
    },
});*/

export default Test;
